import UserForm from './partials/UserForm/UserForm.partial';

const UserAdd = ({...params}) => <UserForm {...params}/>;

export default UserAdd
